import { Component, input, signal } from "@angular/core";
import { ConnectionPositionPair } from "@angular/cdk/overlay";
import { OverlayModule } from "@angular/cdk/overlay";

const DEFAULT_POSITIONS: ConnectionPositionPair[] = [{ originX: "start", originY: "top", overlayX: "start", overlayY: "top", offsetX: 6 }];

@Component({
    selector: "three-dot-menu",
    templateUrl: "./three-dot-menu.component.html",
    styleUrls: ["./three-dot-menu.component.scss"],
    imports: [OverlayModule],
    standalone: true,
})
export class ThreeDotMenuComponent {
    showCloseButton = input<boolean>(true);
    overlayPositions = input<ConnectionPositionPair[]>(DEFAULT_POSITIONS);
    theme = input<"blue">("blue");

    isVisible = signal<boolean>(false);

    toggle(): void {
        this.isVisible.set(!this.isVisible());
    }
}
